"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _client = require("@apollo/client");

var _crossFetch = _interopRequireDefault(require("cross-fetch"));

var _constants = require("./constants");

var PublicClient = /*#__PURE__*/(0, _createClass2["default"])(function PublicClient() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'production';
  (0, _classCallCheck2["default"])(this, PublicClient);

  if (PublicClient.instance) {
    return PublicClient.instance;
  }

  var link = (0, _client.createHttpLink)({
    uri: _constants.GRAPHQL_ENDPOINTS[env],
    credentials: 'include',
    headers: {
      'keep-alive': 'true'
    },
    fetch: _crossFetch["default"]
  });
  var cache = new _client.InMemoryCache();
  var client = new _client.ApolloClient({
    cache: cache,
    link: link
  });
  PublicClient.instance = client;
  return client;
});
PublicClient.instance = null;

var _default = function _default(env) {
  return new PublicClient(env);
};

exports["default"] = _default;